class AutoSaveSoap {
  constructor() {
    this.on_ready = this.on_ready.bind(this);
    this.do_autosave = this.do_autosave.bind(this);
    this.autosave_soap_form = this.autosave_soap_form.bind(this);
    this.update_revision_history = this.update_revision_history.bind(this);
    this.on_post_success = this.on_post_success.bind(this);
  }

  do_autosave() {
    clearTimeout(window.soap_consult);
    var seconds = 1;
    window.soap_consult = setTimeout(this.autosave_soap_form, seconds * 1000);
  }

  autosave_soap_form() {
    var form = $("#soap_form");
    var url = form.data("autosave-url") + ".json";

    if(form.length && url.length) {
      form.find(".js-indicator").html("<i class='fa fa-fw fa-refresh fa-spin'></i>");
      $.ajax({
        type: "post",
        url: url,
        data: form.serialize()
      }).done(this.on_post_success);
    }
  }

  on_post_success(data) {
    if ( data.error_message == null ) {
      $(".js-indicator").html("<i class='fa fa-fw fa-save'></i>");
      $(".js-indicator .fa").fadeOut(2000);
      this.update_revision_history(data);
    } else {
      console.log( data.error_message );
    }
  }

  update_revision_history(consult) {
    var $list = $(".js-version-history-list");
    var url = $list.data('url');
    $.get(url, function(data) {
      $list.html(data)
    });
  }

  on_ready() {
    $(".js-autosubmit").on("keyup", this.do_autosave);
    $(".js-autosubmit").on("change", this.do_autosave);
  }

  get_on_ready() {
    var on_ready = function() { $(".js-autosubmit").on("keyup", this.do_autosave); };
    return on_ready.bind(this);
  }
}

var autosave = new AutoSaveSoap();
$(document).ready(autosave.on_ready);
$(document).on('page:load', autosave.on_ready);